import { GetStoryDiscussionCommentsMeta, GetStoryDiscussionCommentsPayload } from 'types/store/GetStoryDiscussionComments';
import { createAsyncReducer } from 'utils/Redux';

import { getStoryDiscussionCommentsActions } from '../actions';

export default createAsyncReducer<GetStoryDiscussionCommentsMeta, GetStoryDiscussionCommentsPayload>(getStoryDiscussionCommentsActions);
